module.exports = __webpack_public_path__ + "static/media/galerija_2017 (36).ef1e744e.jpg";